export default {
    methods: {
        footjoySelectView() {
        },
    },
};
